export default __webpack_public_path__ + "static/media/win.aa3ddaa5.wav";